import {ColorFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterFlyoutColor} from '@aboutyou/ui-components';
import React from 'react';
import {useColorFilterSection} from '../../shared/useColorFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: ColorFilterSection;
  setFilter: ({
    filterId,
    filterSection,
  }: {
    filterId: string;
    filterSection: string;
  }) => void;
  hide: VoidFunction;
  isOpen: boolean;
  open: VoidFunction;
  submit: VoidFunction;
  enableFlyoutFilter: boolean;
};

export const FilterSectionColor: React.FC<Props> = ({
  activeFilters,
  data,
  setFilter,
  isOpen,
  open,
  hide,
  submit,
  enableFlyoutFilter,
}) => {
  const {activeSlugFilters, label, normalizedColors, slug} =
    useColorFilterSection({activeFilters, data});

  return (
    <FilterFlyoutColor
      activeColorIds={activeSlugFilters}
      colors={normalizedColors}
      key={`filter-flyout-${slug}`}
      label={label}
      onColorClick={colorId => {
        setFilter({
          filterId: colorId,
          filterSection: slug,
        });
      }}
      hide={hide}
      isOpen={isOpen}
      open={open}
      submit={submit}
      enableFlyoutFilter={enableFlyoutFilter}
    />
  );
};
